import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GrupoService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/grupos';
  }

  enable(id: any) {
    return this.httpClient.get(this.baseUrl + `/habilitar/${id}`);
  }

  getHabilitados(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + `/habilitados`);
  }

  register(data: { grupo_id: any; user_id: any }): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + `/register`, data);
  }

  getGrupoByModuloId(idModulo: string): Observable<any[]> {
    return this.httpClient.get<any>(this.baseUrl + `/modulo/${idModulo}`);
  }
}
